<div class="permit-created-container">
    <div class="permit-created-title">
        <div class="permit-created-title-icon">
            <i class="icon-check"></i>
        </div>
        <h2>{{ 'permit.create.created.title' | translate }}</h2>
    </div>

    <div class="permit-card">
        <div class="permit-details">
            <div class="permit-details-header">
                <div class="permit-icon">
                    <i class="icon-folder"></i>
                </div>
                <div class="permit-titles">
                    <h3 class="permit-type">{{ typeName }}</h3>
                    <p class="permit-type-subtitle" *ngIf="typeSubtitle">{{ typeSubtitle }}</p>
                    <h3 class="permit-category" *ngIf="categoryName">{{ categoryName }}</h3>
                </div>
            </div>

            <p class="permit-id" *ngIf="permitId">{{ 'permit.create.created.permit_id' | translate }} {{ permitId }}</p>
        </div>
    </div>

    <button class="close-button" (click)="onClose()">
        {{ 'permit.create.close_button' | translate }}
    </button>
</div>
